<template lang="pug">
  .component-create-entity-button
    ModalReveal(:ref="componentId" )
      button.button.success(slot="trigger") Edit
      .row
        .column
          label Action
            input(type="text", v-model="item.action")
          label Title
            TranslateField(group="entities", :field="item._translatable.title", label="Title", :value="item.title")
              input.input-group-field(type="text", v-model="item.title")
        .column
          label Slug
            input(type="text", v-model="item.slug")
          label Button label
            TranslateField(group="entities", :field="item._translatable.button_labels", label="Button Labels", :value="item.button_labels")
              input.input-group-field(type="text", v-model="item.button_labels")
      .row
        .column
          TranslateField(group="entities", :field="item._translatable.content", label="Content", :value="item.content")
          Editor(v-model="item.content")
      ActionButton(slot="footer" :action="update") Update
</template>

<script>
import ModalReveal from '../../components/structure/foundation/ModalReveal'
import ActionButton from '../../components/structure/ui/ActionButton'
import {mapState} from "vuex";
import collect from "collect.js";
import Editor from "../../components/structure/ui/Editor.vue";
import KeplerBackofficeSdk from "../../lib/kepler/backoffice";
import MaggieHelper from "../../maggieHelper";
import {EventBus} from "../../eventBus";
import TranslateField from "./TranslateField.vue";

export default {
  name: 'EditPageReveal',
  components: {TranslateField, Editor, ActionButton, ModalReveal},
  data() {
    return {
      langs: [],
      body: {
        title: {},
        content: {},
        buttonLabels: {},
        action: ""
      }
    }
  },
  created() {

  },
  methods: {
    update() {
      return KeplerBackofficeSdk.pages.select(this.item.id).edit(this.item, () => {
        MaggieHelper.notification('page updated', 'page updated')
        EventBus.$emit('reload-list')
        this.$refs[this.componentId].close()
      })
    },
  },
  computed: {
    componentId() {
      return `pageReveal-${this._uid}`
    },
  },
  props: {
    item: {}
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// EditPageReveal.vue?243c4b50